<template>
  <div class="bg-documentGray h-full">
    <!-- <div class="shadow"> -->
    <TopAppBar
      :leftBtnMode="leftBtnMode"
      :rightBtnMode="rightBtnMode"
      :title="title"
      :leftBtnMethod="leftBtnMethod"
      :rightBtnMethod="rightBtnMethod"
      staticMode="true"
    ></TopAppBar>
    <!-- </div> -->

    <div id="tab1" class="t-color-bodyGrayA pdt-16 pdb-18">
      <div class="pdl-16 pdr-16 pdt-16px pdb-16px">
        <!-- <div>
          <button
            class="t-helper t-color-white bg-primary d-inline-block mgr-4 pdt-5 pdb-4 pdl-4 pdr-4 b-radius2 l-spacing36 font-r"
          >계정 관리</button>
          <button
            class="t-helper t-color-white bg-mainBtn d-inline-block pdt-5 pdb-4 pdl-4 pdr-4 b-radius2 l-spacing36 font-r"
          >로그인 또는 로그아웃</button>
        </div> -->
        <div class="t-headline7 t-color-headlineBlack l-spacing6 pdt-10 pdb-8 font-m">{{(basicData && basicData.contents)?basicData.contents.subject:''}}</div>
        <div v-if="basicData && basicData.contents" class="t-body3 t-color-bodyGrayA l-spacing42 font-r" v-html="basicData.contents.body">
          <!-- {{(basicData && basicData.contents)?basicData.contents.body:''}} -->
          <br />
          <a v-if="basicData && basicData.contents && basicData.contents.linkUrl" :href="basicData.contents.linkUrl" target="_blank">{{(basicData && basicData.contents)?basicData.contents.linkName:''}}</a>
        </div>
      </div>
      <div class="pdt-16" v-for="(imagepre,i) in (basicData && basicData.contents)?basicData.contents.images:''" :key="i"><img :src="imagepre.resourceUri" alt="" class="attachedImage"></div>
    </div>
  </div>
</template>

<script>
import TopAppBar from "@/components/TopAppBar.vue";
import { topAppBarMixin } from "@/mixins/topAppBar.js";
import noticeApi from "@/api/noticeApi.js";

export default {
  data() {
    return {
      faqId: "",
      basicData: "",
    };
  },
  components: {
    TopAppBar,
  },

  mixins: [topAppBarMixin],

  watch: {
    $route(to, from) {

    },
  },

  mounted() {
    //this.setTopAppBarHomeBlank(this.$t('66'))
    this.setTopAppBarBackHelpDesk(this.$t("3036"));
    this.faqId = this.$router.currentRoute.params.id;
    this.fetchData(this.faqId);
  },
  methods: {
    fetchData(id) {
      let responseData = null;
      this.$showLoading();
      // get Faq Detail
      noticeApi
        .getFaqDetails(id)
        .then((response) => {
          this.basicData = response.data.data;
          // set learning status
          this.$hideLoading();
        })
        .catch((err) => {
          responseData = err.response.data.meta;
          this.$error({ content: responseData.errMsg }).then(() => {});
        });
    },
  },
};
</script>
<style scoped>
.nav-extended .brand-logo,
.nav-content * {
  font-family: noto-regular;
}

.nav-extended .brand-logo {
  font-size: 20px;
  letter-spacing: -0.6;
}

.tabs .tab a:focus,
.tabs .tab a:focus.active {
  background-color: #f5f5f5;
  outline: none;
}

.tabs .indicator {
  background: #2d6dcc;
}

.mdc-elevation--z3 {
            border-radius: 4px;
            box-shadow: 0 1px 3px 0 var(--Shadow1);
            background-color: var(--DocumentWhite);
        }

.b-radius2 {
  border-radius: 2px;
}

.l-spacing36 {
  letter-spacing: -0.36px;
}

.font-16 {
  font-size: 16px;
}

.bg-paymentBlue3 {
  background-color: var(--ContentBlue);
}
</style>